// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"i3eB5":[function(require,module,exports) {
require("7d510d440f046336").register(require("50d2feb878a68a97").getBundleURL("4vDYv"), JSON.parse('["4vDYv","index.1b5fdb01.js","6pYmK","icons.7bb96926.svg"]'));

},{"7d510d440f046336":"44XlC","50d2feb878a68a97":"7Ve2W"}],"44XlC":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"7Ve2W":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"b7Fhu":[function(require,module,exports) {
"use strict";
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require("bb8e178d7d4623");
require("bec2e5afc5fe7e01");

},{"bb8e178d7d4623":"il496","bec2e5afc5fe7e01":"ir2KV"}],"il496":[function(require,module,exports) {
"use strict";
var $ = require("735b6b51288935be");
var globalThis = require("ed39bc7d88ca170e");
var clearImmediate = require("988e04bab5231735").clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$({
    global: true,
    bind: true,
    enumerable: true,
    forced: globalThis.clearImmediate !== clearImmediate
}, {
    clearImmediate: clearImmediate
});

},{"735b6b51288935be":"jCkeC","ed39bc7d88ca170e":"3xuos","988e04bab5231735":"cioqZ"}],"jCkeC":[function(require,module,exports) {
"use strict";
var globalThis = require("553aad19eb2a4b4e");
var getOwnPropertyDescriptor = require("1059f657753910b0").f;
var createNonEnumerableProperty = require("69a5d4191f407ded");
var defineBuiltIn = require("184144fa5f4fde34");
var defineGlobalProperty = require("5420b0c0a35f5356");
var copyConstructorProperties = require("293874fcb4e65dce");
var isForced = require("2ad3ba7289e79f2d");
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = globalThis;
    else if (STATIC) target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
    else target = globalThis[TARGET] && globalThis[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, "sham", true);
        defineBuiltIn(target, key, sourceProperty, options);
    }
};

},{"553aad19eb2a4b4e":"3xuos","1059f657753910b0":"kjago","69a5d4191f407ded":"1J5Tk","184144fa5f4fde34":"dkxOZ","5420b0c0a35f5356":"5xqWt","293874fcb4e65dce":"5opZ5","2ad3ba7289e79f2d":"a9bTY"}],"3xuos":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == "object" && self) || check(typeof global == "object" && global) || check(typeof this == "object" && this) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

},{}],"kjago":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("95e369bf16cb7fb0");
var call = require("c76e9b475265e106");
var propertyIsEnumerableModule = require("850c410d86ac0642");
var createPropertyDescriptor = require("29eba88abf894d06");
var toIndexedObject = require("49d38a1c5c2bd5c6");
var toPropertyKey = require("e4bef67334d934d4");
var hasOwn = require("a6a47bfb36c18d0e");
var IE8_DOM_DEFINE = require("188ba544bfb8caaa");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPropertyKey(P);
    if (IE8_DOM_DEFINE) try {
        return $getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

},{"95e369bf16cb7fb0":"4hm6j","c76e9b475265e106":"5ty8L","850c410d86ac0642":"efI2A","29eba88abf894d06":"1lfQ9","49d38a1c5c2bd5c6":"daObj","e4bef67334d934d4":"hLWyG","a6a47bfb36c18d0e":"4zqZ0","188ba544bfb8caaa":"1haKy"}],"4hm6j":[function(require,module,exports) {
"use strict";
var fails = require("9fdbd214df942e3c");
// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

},{"9fdbd214df942e3c":"dZMni"}],"dZMni":[function(require,module,exports) {
"use strict";
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

},{}],"5ty8L":[function(require,module,exports) {
"use strict";
var NATIVE_BIND = require("1ea12dd95f91750a");
var call = Function.prototype.call;
module.exports = NATIVE_BIND ? call.bind(call) : function() {
    return call.apply(call, arguments);
};

},{"1ea12dd95f91750a":"dXHGV"}],"dXHGV":[function(require,module,exports) {
"use strict";
var fails = require("48563e9403b10c03");
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

},{"48563e9403b10c03":"dZMni"}],"efI2A":[function(require,module,exports) {
"use strict";
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

},{}],"1lfQ9":[function(require,module,exports) {
"use strict";
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

},{}],"daObj":[function(require,module,exports) {
"use strict";
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require("25c60ba3d6190ae7");
var requireObjectCoercible = require("7886f10e0c048590");
module.exports = function(it) {
    return IndexedObject(requireObjectCoercible(it));
};

},{"25c60ba3d6190ae7":"jZusa","7886f10e0c048590":"evagC"}],"jZusa":[function(require,module,exports) {
"use strict";
var uncurryThis = require("fe540e72c8e528ea");
var fails = require("33a974cf0385a581");
var classof = require("9324e4c95f87967f");
var $Object = Object;
var split = uncurryThis("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return classof(it) === "String" ? split(it, "") : $Object(it);
} : $Object;

},{"fe540e72c8e528ea":"5gxVG","33a974cf0385a581":"dZMni","9324e4c95f87967f":"eJ2zT"}],"5gxVG":[function(require,module,exports) {
"use strict";
var NATIVE_BIND = require("2602e9ef09173d82");
var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
module.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
    return function() {
        return call.apply(fn, arguments);
    };
};

},{"2602e9ef09173d82":"dXHGV"}],"eJ2zT":[function(require,module,exports) {
"use strict";
var uncurryThis = require("52f694e85c41001f");
var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis("".slice);
module.exports = function(it) {
    return stringSlice(toString(it), 8, -1);
};

},{"52f694e85c41001f":"5gxVG"}],"evagC":[function(require,module,exports) {
"use strict";
var isNullOrUndefined = require("7e5a83f26aec80cd");
var $TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
    return it;
};

},{"7e5a83f26aec80cd":"h6P7Z"}],"h6P7Z":[function(require,module,exports) {
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

},{}],"hLWyG":[function(require,module,exports) {
"use strict";
var toPrimitive = require("29ae497bed28cf42");
var isSymbol = require("a0a83fe1ba55e122");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = toPrimitive(argument, "string");
    return isSymbol(key) ? key : key + "";
};

},{"29ae497bed28cf42":"2XMJb","a0a83fe1ba55e122":"gfRgh"}],"2XMJb":[function(require,module,exports) {
"use strict";
var call = require("ef03966805824581");
var isObject = require("dad8fe3baf9e133");
var isSymbol = require("18d53f09e261cdce");
var getMethod = require("d7984ab83b721cc5");
var ordinaryToPrimitive = require("bd9e1eaf16988ecc");
var wellKnownSymbol = require("704e5905cb04e33b");
var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!isObject(input) || isSymbol(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = call(exoticToPrim, input, pref);
        if (!isObject(result) || isSymbol(result)) return result;
        throw new $TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return ordinaryToPrimitive(input, pref);
};

},{"ef03966805824581":"5ty8L","dad8fe3baf9e133":"Xd6C5","18d53f09e261cdce":"gfRgh","d7984ab83b721cc5":"aRY56","bd9e1eaf16988ecc":"fXQW5","704e5905cb04e33b":"1bDKt"}],"Xd6C5":[function(require,module,exports) {
"use strict";
var isCallable = require("810c572a0569cea");
module.exports = function(it) {
    return typeof it == "object" ? it !== null : isCallable(it);
};

},{"810c572a0569cea":"gOWcP"}],"gOWcP":[function(require,module,exports) {
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == "undefined" && documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === documentAll;
} : function(argument) {
    return typeof argument == "function";
};

},{}],"gfRgh":[function(require,module,exports) {
"use strict";
var getBuiltIn = require("e637303d39023fff");
var isCallable = require("b86bfc344373e571");
var isPrototypeOf = require("5650ed3a80d0e7e");
var USE_SYMBOL_AS_UID = require("7f1a44800ccc4d97");
var $Object = Object;
module.exports = USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = getBuiltIn("Symbol");
    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

},{"e637303d39023fff":"05db4","b86bfc344373e571":"gOWcP","5650ed3a80d0e7e":"lrumX","7f1a44800ccc4d97":"030OR"}],"05db4":[function(require,module,exports) {
"use strict";
var globalThis = require("f6d1def15fe6ab89");
var isCallable = require("c1bb9181cf50f536");
var aFunction = function(argument) {
    return isCallable(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};

},{"f6d1def15fe6ab89":"3xuos","c1bb9181cf50f536":"gOWcP"}],"lrumX":[function(require,module,exports) {
"use strict";
var uncurryThis = require("b92746f17c3a3beb");
module.exports = uncurryThis({}.isPrototypeOf);

},{"b92746f17c3a3beb":"5gxVG"}],"030OR":[function(require,module,exports) {
"use strict";
/* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = require("978611fe376f7856");
module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";

},{"978611fe376f7856":"lxile"}],"lxile":[function(require,module,exports) {
"use strict";
/* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = require("b5fb7a11f1a3649f");
var fails = require("617dc4c3000db008");
var globalThis = require("8eb8bfe0221630cd");
var $String = globalThis.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

},{"b5fb7a11f1a3649f":"lPLiN","617dc4c3000db008":"dZMni","8eb8bfe0221630cd":"3xuos"}],"lPLiN":[function(require,module,exports) {
"use strict";
var globalThis = require("fac6bed07ccdedee");
var userAgent = require("b4676206562c9c89");
var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
module.exports = version;

},{"fac6bed07ccdedee":"3xuos","b4676206562c9c89":"hWa8Q"}],"hWa8Q":[function(require,module,exports) {
"use strict";
var globalThis = require("f5e141a8e421c796");
var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;
module.exports = userAgent ? String(userAgent) : "";

},{"f5e141a8e421c796":"3xuos"}],"aRY56":[function(require,module,exports) {
"use strict";
var aCallable = require("34a4f2a300fa7ad2");
var isNullOrUndefined = require("2826a2f11cf1e713");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return isNullOrUndefined(func) ? undefined : aCallable(func);
};

},{"34a4f2a300fa7ad2":"jyrk0","2826a2f11cf1e713":"h6P7Z"}],"jyrk0":[function(require,module,exports) {
"use strict";
var isCallable = require("75c69e98f404e52e");
var tryToString = require("3e69b7d1b040e60d");
var $TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if (isCallable(argument)) return argument;
    throw new $TypeError(tryToString(argument) + " is not a function");
};

},{"75c69e98f404e52e":"gOWcP","3e69b7d1b040e60d":"cmtfZ"}],"cmtfZ":[function(require,module,exports) {
"use strict";
var $String = String;
module.exports = function(argument) {
    try {
        return $String(argument);
    } catch (error) {
        return "Object";
    }
};

},{}],"fXQW5":[function(require,module,exports) {
"use strict";
var call = require("e09763feffbbb30");
var isCallable = require("7681371c4d3e3868");
var isObject = require("8b336b4688bfc632");
var $TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
    if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    throw new $TypeError("Can't convert object to primitive value");
};

},{"e09763feffbbb30":"5ty8L","7681371c4d3e3868":"gOWcP","8b336b4688bfc632":"Xd6C5"}],"1bDKt":[function(require,module,exports) {
"use strict";
var globalThis = require("338f3e2be26d75f8");
var shared = require("dd18a19e922caac9");
var hasOwn = require("7947ee679df4ed6");
var uid = require("47d8a9e835e8bbc5");
var NATIVE_SYMBOL = require("8b970e79550001f6");
var USE_SYMBOL_AS_UID = require("97d34c0e4c01a94f");
var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared("wks");
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol["for"] || Symbol : Symbol && Symbol.withoutSetter || uid;
module.exports = function(name) {
    if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name) ? Symbol[name] : createWellKnownSymbol("Symbol." + name);
    return WellKnownSymbolsStore[name];
};

},{"338f3e2be26d75f8":"3xuos","dd18a19e922caac9":"wwPLl","7947ee679df4ed6":"4zqZ0","47d8a9e835e8bbc5":"eGcq3","8b970e79550001f6":"lxile","97d34c0e4c01a94f":"030OR"}],"wwPLl":[function(require,module,exports) {
"use strict";
var store = require("a0d81b935eb43451");
module.exports = function(key, value) {
    return store[key] || (store[key] = value || {});
};

},{"a0d81b935eb43451":"e4JCe"}],"e4JCe":[function(require,module,exports) {
"use strict";
var IS_PURE = require("f65b3b7b0e3eda6b");
var globalThis = require("e75157408f11cbd7");
var defineGlobalProperty = require("28c7aac4b39459e2");
var SHARED = "__core-js_shared__";
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});
(store.versions || (store.versions = [])).push({
    version: "3.38.1",
    mode: IS_PURE ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

},{"f65b3b7b0e3eda6b":"i96Ym","e75157408f11cbd7":"3xuos","28c7aac4b39459e2":"5xqWt"}],"i96Ym":[function(require,module,exports) {
"use strict";
module.exports = false;

},{}],"5xqWt":[function(require,module,exports) {
"use strict";
var globalThis = require("f2cedc7dc33a7018");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        defineProperty(globalThis, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        globalThis[key] = value;
    }
    return value;
};

},{"f2cedc7dc33a7018":"3xuos"}],"4zqZ0":[function(require,module,exports) {
"use strict";
var uncurryThis = require("ac41d2548ed08f31");
var toObject = require("c17f7b8d032f572e");
var hasOwnProperty = uncurryThis({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject(it), key);
};

},{"ac41d2548ed08f31":"5gxVG","c17f7b8d032f572e":"cV8cg"}],"cV8cg":[function(require,module,exports) {
"use strict";
var requireObjectCoercible = require("42beb5397f7187c2");
var $Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $Object(requireObjectCoercible(argument));
};

},{"42beb5397f7187c2":"evagC"}],"eGcq3":[function(require,module,exports) {
"use strict";
var uncurryThis = require("63c2aa58106465be");
var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString(++id + postfix, 36);
};

},{"63c2aa58106465be":"5gxVG"}],"1haKy":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("6f627c0db7b3ca85");
var fails = require("ddf59b6147c0d7ed");
var createElement = require("2e07f9b74a7eafcd");
// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(createElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

},{"6f627c0db7b3ca85":"4hm6j","ddf59b6147c0d7ed":"dZMni","2e07f9b74a7eafcd":"bDe1k"}],"bDe1k":[function(require,module,exports) {
"use strict";
var globalThis = require("8b20b5837be08bf3");
var isObject = require("5739ca3816493930");
var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);
module.exports = function(it) {
    return EXISTS ? document.createElement(it) : {};
};

},{"8b20b5837be08bf3":"3xuos","5739ca3816493930":"Xd6C5"}],"1J5Tk":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("2a8ca9503499427d");
var definePropertyModule = require("b6f7797e465e92e4");
var createPropertyDescriptor = require("9634a52337b1d316");
module.exports = DESCRIPTORS ? function(object, key, value) {
    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

},{"2a8ca9503499427d":"4hm6j","b6f7797e465e92e4":"dUGZM","9634a52337b1d316":"1lfQ9"}],"dUGZM":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("db0ce8d64f5198d2");
var IE8_DOM_DEFINE = require("6d935ed1ad451e2e");
var V8_PROTOTYPE_DEFINE_BUG = require("3344a336094ae986");
var anObject = require("d17b88ecdcee2a1e");
var toPropertyKey = require("93e6496f622da969");
var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE = "configurable";
var WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor(O, P);
        if (current && current[WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
            };
        }
    }
    return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

},{"db0ce8d64f5198d2":"4hm6j","6d935ed1ad451e2e":"1haKy","3344a336094ae986":"8ANUA","d17b88ecdcee2a1e":"ljFHM","93e6496f622da969":"hLWyG"}],"8ANUA":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("72557e6a3213972a");
var fails = require("cc880f9942e2a3a7");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});

},{"72557e6a3213972a":"4hm6j","cc880f9942e2a3a7":"dZMni"}],"ljFHM":[function(require,module,exports) {
"use strict";
var isObject = require("55a9aa48bec23519");
var $String = String;
var $TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if (isObject(argument)) return argument;
    throw new $TypeError($String(argument) + " is not an object");
};

},{"55a9aa48bec23519":"Xd6C5"}],"dkxOZ":[function(require,module,exports) {
"use strict";
var isCallable = require("a1c2868cd8d81c8f");
var definePropertyModule = require("ee3b641fc5c445bf");
var makeBuiltIn = require("7c6c8740945b7d");
var defineGlobalProperty = require("85b4ee981af67154");
module.exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if (isCallable(value)) makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else defineGlobalProperty(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else definePropertyModule.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};

},{"a1c2868cd8d81c8f":"gOWcP","ee3b641fc5c445bf":"dUGZM","7c6c8740945b7d":"dt9wA","85b4ee981af67154":"5xqWt"}],"dt9wA":[function(require,module,exports) {
"use strict";
var uncurryThis = require("c71b6c1f1cb15f4");
var fails = require("dbb04abdc1404e68");
var isCallable = require("828afae22a0a76d8");
var hasOwn = require("aa43bf76f0b67ebd");
var DESCRIPTORS = require("b6d9514b27f474db");
var CONFIGURABLE_FUNCTION_NAME = require("14224133709c5121").CONFIGURABLE;
var inspectSource = require("23403ba9e1877e7f");
var InternalStateModule = require("a3c90d2c050453fb");
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis("".slice);
var replace = uncurryThis("".replace);
var join = uncurryThis([].join);
var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
    return defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var TEMPLATE = String(String).split("String");
var makeBuiltIn = module.exports = function(value, name, options) {
    if (stringSlice($String(name), 0, 7) === "Symbol(") name = "[" + replace($String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!hasOwn(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if (DESCRIPTORS) defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if (CONFIGURABLE_LENGTH && options && hasOwn(options, "arity") && value.length !== options.arity) defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && hasOwn(options, "constructor") && options.constructor) {
            if (DESCRIPTORS) defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = enforceInternalState(value);
    if (!hasOwn(state, "source")) state.source = join(TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, "toString");

},{"c71b6c1f1cb15f4":"5gxVG","dbb04abdc1404e68":"dZMni","828afae22a0a76d8":"gOWcP","aa43bf76f0b67ebd":"4zqZ0","b6d9514b27f474db":"4hm6j","14224133709c5121":"jx1nQ","23403ba9e1877e7f":"8GNxc","a3c90d2c050453fb":"ajvfL"}],"jx1nQ":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("7c12826b439e1832");
var hasOwn = require("2ea2b033d19a1c29");
var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn(FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() {}).name === "something";
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
};

},{"7c12826b439e1832":"4hm6j","2ea2b033d19a1c29":"4zqZ0"}],"8GNxc":[function(require,module,exports) {
"use strict";
var uncurryThis = require("1b12895e85eb9b9d");
var isCallable = require("af987a866f12bbd6");
var store = require("3c2463c43dabfed1");
var functionToString = uncurryThis(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
    return functionToString(it);
};
module.exports = store.inspectSource;

},{"1b12895e85eb9b9d":"5gxVG","af987a866f12bbd6":"gOWcP","3c2463c43dabfed1":"e4JCe"}],"ajvfL":[function(require,module,exports) {
"use strict";
var NATIVE_WEAK_MAP = require("7ae98a2fa6322af7");
var globalThis = require("f0974827234751a2");
var isObject = require("83d08207eee4399a");
var createNonEnumerableProperty = require("75c3739716e102f0");
var hasOwn = require("6bb4f9b697dd4b72");
var shared = require("42f34be2c9039e50");
var sharedKey = require("78511af84ac9b3d6");
var hiddenKeys = require("7229d891658e611f");
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;
var enforce = function(it) {
    return has(it) ? get(it) : set(it, {});
};
var getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if (NATIVE_WEAK_MAP || shared.state) {
    var store = shared.state || (shared.state = new WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
    store.has = store.has;
    store.set = store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
        if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store.set(it, metadata);
        return metadata;
    };
    get = function(it) {
        return store.get(it) || {};
    };
    has = function(it) {
        return store.has(it);
    };
} else {
    var STATE = sharedKey("state");
    hiddenKeys[STATE] = true;
    set = function(it, metadata) {
        if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
    };
    get = function(it) {
        return hasOwn(it, STATE) ? it[STATE] : {};
    };
    has = function(it) {
        return hasOwn(it, STATE);
    };
}
module.exports = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};

},{"7ae98a2fa6322af7":"fBFmj","f0974827234751a2":"3xuos","83d08207eee4399a":"Xd6C5","75c3739716e102f0":"1J5Tk","6bb4f9b697dd4b72":"4zqZ0","42f34be2c9039e50":"e4JCe","78511af84ac9b3d6":"khYmN","7229d891658e611f":"95D84"}],"fBFmj":[function(require,module,exports) {
"use strict";
var globalThis = require("716aeaaba10edfbb");
var isCallable = require("7754d968254bb7a8");
var WeakMap = globalThis.WeakMap;
module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

},{"716aeaaba10edfbb":"3xuos","7754d968254bb7a8":"gOWcP"}],"khYmN":[function(require,module,exports) {
"use strict";
var shared = require("16ed8fffd7354747");
var uid = require("6327fce2bf924665");
var keys = shared("keys");
module.exports = function(key) {
    return keys[key] || (keys[key] = uid(key));
};

},{"16ed8fffd7354747":"wwPLl","6327fce2bf924665":"eGcq3"}],"95D84":[function(require,module,exports) {
"use strict";
module.exports = {};

},{}],"5opZ5":[function(require,module,exports) {
"use strict";
var hasOwn = require("6e449e05bef6f331");
var ownKeys = require("41e3c877237aa");
var getOwnPropertyDescriptorModule = require("9f6cc2471aadc490");
var definePropertyModule = require("7374cc8652242591");
module.exports = function(target, source, exceptions) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

},{"6e449e05bef6f331":"4zqZ0","41e3c877237aa":"3I6rw","9f6cc2471aadc490":"kjago","7374cc8652242591":"dUGZM"}],"3I6rw":[function(require,module,exports) {
"use strict";
var getBuiltIn = require("e022f566ca7e73f7");
var uncurryThis = require("ff8f1b5a008cd08a");
var getOwnPropertyNamesModule = require("1d2d63810b091238");
var getOwnPropertySymbolsModule = require("d3ba7aa182f15964");
var anObject = require("ff272ab5cd01c3ad");
var concat = uncurryThis([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

},{"e022f566ca7e73f7":"05db4","ff8f1b5a008cd08a":"5gxVG","1d2d63810b091238":"5NB4o","d3ba7aa182f15964":"lhDCH","ff272ab5cd01c3ad":"ljFHM"}],"5NB4o":[function(require,module,exports) {
"use strict";
var internalObjectKeys = require("afd89f0ce6e9ee90");
var enumBugKeys = require("aa5f6ed3b750d517");
var hiddenKeys = enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys(O, hiddenKeys);
};

},{"afd89f0ce6e9ee90":"hlI6v","aa5f6ed3b750d517":"9DRNU"}],"hlI6v":[function(require,module,exports) {
"use strict";
var uncurryThis = require("73c8f04e0bbd0091");
var hasOwn = require("1100641c57cc42ba");
var toIndexedObject = require("1ec0d0dbf10f479f");
var indexOf = require("4e73283c11a6daf7").indexOf;
var hiddenKeys = require("5c6785f414ee2ac0");
var push = uncurryThis([].push);
module.exports = function(object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
    return result;
};

},{"73c8f04e0bbd0091":"5gxVG","1100641c57cc42ba":"4zqZ0","1ec0d0dbf10f479f":"daObj","4e73283c11a6daf7":"jHpX3","5c6785f414ee2ac0":"95D84"}],"jHpX3":[function(require,module,exports) {
"use strict";
var toIndexedObject = require("2db13fcd8bf45f3");
var toAbsoluteIndex = require("f421ce3d81b48a96");
var lengthOfArrayLike = require("6ac1ccb09ab46404");
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = lengthOfArrayLike(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
};

},{"2db13fcd8bf45f3":"daObj","f421ce3d81b48a96":"8qEZt","6ac1ccb09ab46404":"3g6eX"}],"8qEZt":[function(require,module,exports) {
"use strict";
var toIntegerOrInfinity = require("37ff4de050af946a");
var max = Math.max;
var min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = toIntegerOrInfinity(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

},{"37ff4de050af946a":"czz31"}],"czz31":[function(require,module,exports) {
"use strict";
var trunc = require("460e7e59bff81edf");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : trunc(number);
};

},{"460e7e59bff81edf":"1uNoT"}],"1uNoT":[function(require,module,exports) {
"use strict";
var ceil = Math.ceil;
var floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? floor : ceil)(n);
};

},{}],"3g6eX":[function(require,module,exports) {
"use strict";
var toLength = require("c193f7b3b0ba14b5");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return toLength(obj.length);
};

},{"c193f7b3b0ba14b5":"cYHFg"}],"cYHFg":[function(require,module,exports) {
"use strict";
var toIntegerOrInfinity = require("907399f1bcf18b1");
var min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = toIntegerOrInfinity(argument);
    return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

},{"907399f1bcf18b1":"czz31"}],"9DRNU":[function(require,module,exports) {
"use strict";
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

},{}],"lhDCH":[function(require,module,exports) {
"use strict";
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

},{}],"a9bTY":[function(require,module,exports) {
"use strict";
var fails = require("dd0cbf7f1064e310");
var isCallable = require("3846989a964620db");
var replacement = /#|\.prototype\./;
var isForced = function(feature, detection) {
    var value = data[normalize(feature)];
    return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function(string) {
    return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = "N";
var POLYFILL = isForced.POLYFILL = "P";
module.exports = isForced;

},{"dd0cbf7f1064e310":"dZMni","3846989a964620db":"gOWcP"}],"cioqZ":[function(require,module,exports) {
"use strict";
var globalThis = require("b6ca31a60ebc239a");
var apply = require("737176c5a9de9f4a");
var bind = require("a620ce566995d13c");
var isCallable = require("b530290e23b79dc1");
var hasOwn = require("e0247395d70c065");
var fails = require("2e719bdceca5f7c9");
var html = require("427cce475ba35738");
var arraySlice = require("c41279fb1550076e");
var createElement = require("555967d6185f778f");
var validateArgumentsLength = require("98f8f094ce9a09d7");
var IS_IOS = require("a49b42780571701f");
var IS_NODE = require("56cf5fe0e0dc871c");
var set = globalThis.setImmediate;
var clear = globalThis.clearImmediate;
var process = globalThis.process;
var Dispatch = globalThis.Dispatch;
var Function = globalThis.Function;
var MessageChannel = globalThis.MessageChannel;
var String = globalThis.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = "onreadystatechange";
var $location, defer, channel, port;
fails(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $location = globalThis.location;
});
var run = function(id) {
    if (hasOwn(queue, id)) {
        var fn = queue[id];
        delete queue[id];
        fn();
    }
};
var runner = function(id) {
    return function() {
        run(id);
    };
};
var eventListener = function(event) {
    run(event.data);
};
var globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    globalThis.postMessage(String(id), $location.protocol + "//" + $location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
    set = function setImmediate(handler) {
        validateArgumentsLength(arguments.length, 1);
        var fn = isCallable(handler) ? handler : Function(handler);
        var args = arraySlice(arguments, 1);
        queue[++counter] = function() {
            apply(fn, undefined, args);
        };
        defer(counter);
        return counter;
    };
    clear = function clearImmediate(id) {
        delete queue[id];
    };
    // Node.js 0.8-
    if (IS_NODE) defer = function(id) {
        process.nextTick(runner(id));
    };
    else if (Dispatch && Dispatch.now) defer = function(id) {
        Dispatch.now(runner(id));
    };
    else if (MessageChannel && !IS_IOS) {
        channel = new MessageChannel();
        port = channel.port2;
        channel.port1.onmessage = eventListener;
        defer = bind(port.postMessage, port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (globalThis.addEventListener && isCallable(globalThis.postMessage) && !globalThis.importScripts && $location && $location.protocol !== "file:" && !fails(globalPostMessageDefer)) {
        defer = globalPostMessageDefer;
        globalThis.addEventListener("message", eventListener, false);
    // IE8-
    } else if (ONREADYSTATECHANGE in createElement("script")) defer = function(id) {
        html.appendChild(createElement("script"))[ONREADYSTATECHANGE] = function() {
            html.removeChild(this);
            run(id);
        };
    };
    else defer = function(id) {
        setTimeout(runner(id), 0);
    };
}
module.exports = {
    set: set,
    clear: clear
};

},{"b6ca31a60ebc239a":"3xuos","737176c5a9de9f4a":"20WNj","a620ce566995d13c":"1X3U2","b530290e23b79dc1":"gOWcP","e0247395d70c065":"4zqZ0","2e719bdceca5f7c9":"dZMni","427cce475ba35738":"5u55J","c41279fb1550076e":"1LigJ","555967d6185f778f":"bDe1k","98f8f094ce9a09d7":"4hrBf","a49b42780571701f":"3K7Jc","56cf5fe0e0dc871c":"6LQP2"}],"20WNj":[function(require,module,exports) {
"use strict";
var NATIVE_BIND = require("164a261c6a32b679");
var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
    return call.apply(apply, arguments);
});

},{"164a261c6a32b679":"dXHGV"}],"1X3U2":[function(require,module,exports) {
"use strict";
var uncurryThis = require("a69f4e104e3b946c");
var aCallable = require("de8bbf40ea1528c8");
var NATIVE_BIND = require("8d6c3a6b97685d2f");
var bind = uncurryThis(uncurryThis.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    aCallable(fn);
    return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

},{"a69f4e104e3b946c":"kXGBu","de8bbf40ea1528c8":"jyrk0","8d6c3a6b97685d2f":"dXHGV"}],"kXGBu":[function(require,module,exports) {
"use strict";
var classofRaw = require("8fc2a23b9f210bf9");
var uncurryThis = require("2064caa31449c85f");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if (classofRaw(fn) === "Function") return uncurryThis(fn);
};

},{"8fc2a23b9f210bf9":"eJ2zT","2064caa31449c85f":"5gxVG"}],"5u55J":[function(require,module,exports) {
"use strict";
var getBuiltIn = require("bc5b4cd45392bb1a");
module.exports = getBuiltIn("document", "documentElement");

},{"bc5b4cd45392bb1a":"05db4"}],"1LigJ":[function(require,module,exports) {
"use strict";
var uncurryThis = require("5087052dc74881ce");
module.exports = uncurryThis([].slice);

},{"5087052dc74881ce":"5gxVG"}],"4hrBf":[function(require,module,exports) {
"use strict";
var $TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $TypeError("Not enough arguments");
    return passed;
};

},{}],"3K7Jc":[function(require,module,exports) {
"use strict";
var userAgent = require("a83cab93c9f9ed5e");
// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);

},{"a83cab93c9f9ed5e":"hWa8Q"}],"6LQP2":[function(require,module,exports) {
"use strict";
var ENVIRONMENT = require("31f8eb5ee7c37116");
module.exports = ENVIRONMENT === "NODE";

},{"31f8eb5ee7c37116":"1m3K4"}],"1m3K4":[function(require,module,exports) {
"use strict";
/* global Bun, Deno -- detection */ var globalThis = require("483867ee4c8f45c0");
var userAgent = require("9124843d2c0f99e0");
var classof = require("3fc9bf05190485a1");
var userAgentStartsWith = function(string) {
    return userAgent.slice(0, string.length) === string;
};
module.exports = function() {
    if (userAgentStartsWith("Bun/")) return "BUN";
    if (userAgentStartsWith("Cloudflare-Workers")) return "CLOUDFLARE";
    if (userAgentStartsWith("Deno/")) return "DENO";
    if (userAgentStartsWith("Node.js/")) return "NODE";
    if (globalThis.Bun && typeof Bun.version == "string") return "BUN";
    if (globalThis.Deno && typeof Deno.version == "object") return "DENO";
    if (classof(globalThis.process) === "process") return "NODE";
    if (globalThis.window && globalThis.document) return "BROWSER";
    return "REST";
}();

},{"483867ee4c8f45c0":"3xuos","9124843d2c0f99e0":"hWa8Q","3fc9bf05190485a1":"eJ2zT"}],"ir2KV":[function(require,module,exports) {
"use strict";
var $ = require("da2d6a94ea0ba043");
var globalThis = require("19f4438a6746bba9");
var setTask = require("9e785d31fea1ded9").set;
var schedulersFix = require("3acfc285ffd4a76d");
// https://github.com/oven-sh/bun/issues/1633
var setImmediate = globalThis.setImmediate ? schedulersFix(setTask, false) : setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$({
    global: true,
    bind: true,
    enumerable: true,
    forced: globalThis.setImmediate !== setImmediate
}, {
    setImmediate: setImmediate
});

},{"da2d6a94ea0ba043":"jCkeC","19f4438a6746bba9":"3xuos","9e785d31fea1ded9":"cioqZ","3acfc285ffd4a76d":"hAlAH"}],"hAlAH":[function(require,module,exports) {
"use strict";
var globalThis = require("f16d48dd4458b6f3");
var apply = require("8bc159acb2686f76");
var isCallable = require("f9a5b99e5440e01c");
var ENVIRONMENT = require("e81c41615c347514");
var USER_AGENT = require("154e9df45094427d");
var arraySlice = require("8434cb66e99f86d7");
var validateArgumentsLength = require("b012924730be79de");
var Function = globalThis.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENVIRONMENT === "BUN" && function() {
    var version = globalThis.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
        var fn = isCallable(handler) ? handler : Function(handler);
        var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            apply(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};

},{"f16d48dd4458b6f3":"3xuos","8bc159acb2686f76":"20WNj","f9a5b99e5440e01c":"gOWcP","e81c41615c347514":"1m3K4","154e9df45094427d":"hWa8Q","8434cb66e99f86d7":"1LigJ","b012924730be79de":"4hrBf"}],"5XrL7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "state", ()=>state);
parcelHelpers.export(exports, "loadRecipe", ()=>loadRecipe);
parcelHelpers.export(exports, "loadSearchResults", ()=>loadSearchResults);
parcelHelpers.export(exports, "getSearchResultsPage", ()=>getSearchResultsPage);
parcelHelpers.export(exports, "updateServings", ()=>updateServings);
parcelHelpers.export(exports, "addBookmark", ()=>addBookmark);
parcelHelpers.export(exports, "deleteBookmark", ()=>deleteBookmark);
parcelHelpers.export(exports, "uploadRecipe", ()=>uploadRecipe);
parcelHelpers.export(exports, "clearIngredients", ()=>clearIngredients);
parcelHelpers.export(exports, "addIngredient", ()=>addIngredient);
parcelHelpers.export(exports, "removeIngredient", ()=>removeIngredient);
parcelHelpers.export(exports, "submitListData", ()=>submitListData);
parcelHelpers.export(exports, "clearPlanner", ()=>clearPlanner);
parcelHelpers.export(exports, "deleteMeal", ()=>deleteMeal);
parcelHelpers.export(exports, "addPlannedMeal", ()=>addPlannedMeal);
parcelHelpers.export(exports, "changeWeek", ()=>changeWeek);
parcelHelpers.export(exports, "changeActive", ()=>changeActive);
parcelHelpers.export(exports, "clearLocalStorage", ()=>clearLocalStorage);
parcelHelpers.export(exports, "changeTheme", ()=>changeTheme);
var _configJs = require("./config.js");
var _helpersJs = require("./helpers.js");
const state = {
    theme: "light",
    recipe: {},
    search: {
        query: "",
        results: [],
        resultsPerPage: (0, _configJs.RES_PER_PAGE),
        page: 1
    },
    bookmarks: [],
    ingredientsList: [],
    planner: {
        currentWeek: [
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ]
        ],
        nextWeek: [
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ]
        ],
        page: 1,
        date: new Date(),
        active: 0
    },
    lastMonday: (0, _configJs.FIRST_MONDAY)
};
const createRecipeObject = function(data) {
    const { recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const getTotalNutrientAmount = function(ingredientsArr, nutrient) {
    return ingredientsArr.map((ing)=>ing.nutrition?.nutrients.find((nutr)=>nutr.name === nutrient[0].toUpperCase() + nutrient.slice(1))?.amount ?? 0).reduce((acc, ingNutr)=>acc + ingNutr, 0);
};
const loadRecipe = async function(id) {
    try {
        const data = await (0, _helpersJs.AJAX)(`${(0, _configJs.API_URL)}${id}?key=${(0, _configJs.KEY)}`);
        state.recipe = createRecipeObject(data);
        //Check for bookmarks
        if (state.bookmarks.some((bookmark)=>bookmark.id === id)) state.recipe.bookmarked = true;
        else state.recipe.bookmarked = false;
        const ingredientList = state.recipe.ingredients.map((ing)=>`${ing.quantity ?? ""} ${ing.unit ?? ""} ${ing.description}`).join("\n");
        const ingredientsData = await (0, _helpersJs.AJAX)(`${(0, _configJs.SPOONACULAR_ENDPOINT)}?apiKey=${(0, _configJs.SPOONACULAR_API_KEY)}`, {
            ingredientList: ingredientList,
            servings: state.recipe.servings,
            includeNutrition: true
        }, "application/x-www-form-urlencoded");
        const calories = getTotalNutrientAmount(ingredientsData, "calories");
        const carbs = getTotalNutrientAmount(ingredientsData, "carbohydrates");
        const proteins = getTotalNutrientAmount(ingredientsData, "protein");
        const fats = getTotalNutrientAmount(ingredientsData, "fat");
        state.recipe.calories = Math.floor(calories / state.recipe.servings);
        state.recipe.carbs = Math.floor(carbs / state.recipe.servings);
        state.recipe.proteins = Math.floor(proteins / state.recipe.servings);
        state.recipe.fats = Math.floor(fats / state.recipe.servings);
    // console.log(state.recipe);
    } catch (err) {
        if (err.message.slice(-3) === "402") {
            state.recipe.calories = undefined;
            state.recipe.carbs = undefined;
            state.recipe.proteins = undefined;
            state.recipe.proteins = undefined;
        }
        throw err;
    }
};
const loadSearchResults = async function(query) {
    try {
        state.search, query;
        const data = await (0, _helpersJs.AJAX)(`${(0, _configJs.API_URL)}?search=${query}&key=${(0, _configJs.KEY)}`);
        state.search.results = data.data.recipes.map((rec)=>{
            return {
                id: rec.id,
                title: rec.title,
                publisher: rec.publisher,
                image: rec.image_url,
                ...rec.key && {
                    key: rec.key
                }
            };
        });
        state.search.page = 1;
    } catch (err) {
        console.error(`${err} \u{26A0}\u{26A0}\u{26A0}`);
        throw err;
    }
};
const getSearchResultsPage = function(page = state.search.page) {
    state.search.page = page;
    const start = (page - 1) * state.search.resultsPerPage;
    const end = page * state.search.resultsPerPage;
    return state.search.results.slice(start, end);
};
const updateServings = function(newServings) {
    state.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * newServings / state.recipe.servings;
    // newQt = oldQt * newServings / oldServings
    });
    state.recipe.servings = newServings;
};
const persistBookmarks = function() {
    localStorage.setItem("bookmarks", JSON.stringify(state.bookmarks));
};
const addBookmark = function(recipe) {
    // Add bookmark
    state.bookmarks.push(recipe);
    //Mark current recipe as bookmarked
    if (recipe.id === state.recipe.id) state.recipe.bookmarked = true;
    persistBookmarks();
};
const deleteBookmark = function(id) {
    //Delete bookmark
    const index = state.bookmarks.findIndex((el)=>el.id === id);
    state.bookmarks.splice(index, 1);
    //Mark current recipe as not bookmarked
    if (id === state.recipe.id) state.recipe.bookmarked = false;
    persistBookmarks();
};
const uploadRecipe = async function(newRecipe) {
    try {
        //Getting the ingredients from the form
        const ingredients = (0, _helpersJs.formatIngredientsArr)(newRecipe);
        // Preparing the recipe object for API POST request
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: (0, _configJs.SERVINGS_TO_UPLOAD),
            ingredients
        };
        const data = await (0, _helpersJs.AJAX)(`${(0, _configJs.API_URL)}?key=${(0, _configJs.KEY)}`, recipe, `application/json`);
        state.recipe = createRecipeObject(data);
        addBookmark(state.recipe);
    } catch (err) {
        throw err;
    }
};
const persistIngredients = function() {
    localStorage.setItem("ingredients", JSON.stringify(state.ingredientsList));
};
const clearIngredients = function() {
    // localStorage.removeItem('ingredients');
    state.ingredientsList = [
        "My shopping list"
    ];
    persistIngredients();
};
const addIngredient = function(ingredient) {
    state.ingredientsList.push(ingredient);
    persistIngredients();
};
const removeIngredient = function(ingredient) {
    const ingIndex = state.ingredientsList.findIndex((ing)=>ing.trim() === ingredient.trim());
    state.ingredientsList.splice(ingIndex, 1);
    persistIngredients();
};
const submitListData = function(formData) {
    clearIngredients();
    if (formData[0][1] === "") formData[0][1] = "My shopping list";
    const newArray = formData.map((ing)=>ing[1]).filter((ing)=>ing !== "");
    state.ingredientsList = newArray;
    persistIngredients();
};
const persistPlanner = function() {
    localStorage.setItem("plannerData", JSON.stringify(state.planner));
};
const clearPlanner = function() {
    localStorage.removeItem("plannerData");
    state.planner = {
        currentWeek: [
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ]
        ],
        nextWeek: [
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ],
            [
                "",
                "",
                "",
                ""
            ]
        ],
        page: 1,
        date: new Date(),
        active: 0
    };
    persistPlanner();
};
const deleteMeal = function(indexDay, indexMeal) {
    state.planner[state.planner.page === 1 ? "currentWeek" : "nextWeek"][indexDay][indexMeal] = "";
    persistPlanner();
};
const addPlannedMeal = function(meal) {
    state.planner[meal.week][meal.weekday][meal.meal] = meal.recipe;
    persistPlanner();
};
const changeWeek = function(newWeek) {
    state.planner.page = newWeek;
    persistPlanner();
};
const changeActive = function(active) {
    state.planner.active = active;
    persistPlanner();
};
const updateWeek = function() {
    const newCurrent = state.planner.nextWeek.map((day)=>day.map((meal)=>meal));
    const newNext = [
        [
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            ""
        ]
    ];
    console.log(newCurrent);
    state.planner.currentWeek = newCurrent;
    state.planner.nextWeek = newNext;
    persistPlanner();
};
const persistMonday = function() {
    localStorage.setItem("lastMonday", JSON.stringify(state.lastMonday));
};
const updateDate = function() {
    // console.log(state.lastMonday);
    // console.log(new Date());
    const passedDays = Math.trunc((0, _helpersJs.calcDaysPassed)(state.lastMonday, new Date()));
    // There have passed less than 7 days
    if (passedDays < 7) return;
    // It has passed exactly one week => it's monday
    if (passedDays === 7) {
        state.lastMonday = new Date();
        updateWeek();
    }
    // It has passed more than a week
    if (passedDays > 7) {
        const weeks = Math.trunc(passedDays / 7);
        const remainder = passedDays % 7;
        state.lastMonday = new Date() - remainder * (0, _configJs.MS_PER_DAY);
        // Update if there has passed only one week
        if (weeks === 1) updateWeek();
        // Empty if there have passed 2+ weeks
        if (weeks > 1) {
            state.planner.currentWeek = [
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ]
            ];
            state.planner.nextWeek = [
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    ""
                ]
            ];
        }
    }
    persistMonday(); //Update in local storage
};
const clearDate = function() {
    localStorage.removeItem("lastMonday");
};
const clearLocalStorage = function() {
    clearDate();
    clearPlanner();
    localStorage.removeItem("bookmarks");
    localStorage.removeItem("lastMonday");
};
const persistTheme = function() {
    localStorage.setItem("theme", JSON.stringify(state.theme));
};
const changeTheme = function(theme) {
    state.theme = theme;
    persistTheme();
};
const init = function() {
    const bookmarksStorage = localStorage.getItem("bookmarks");
    const ingListStorage = localStorage.getItem("ingredients");
    const plannedMealsStorage = localStorage.getItem("plannerData");
    const mondayStorage = localStorage.getItem("lastMonday");
    const themeStorage = localStorage.getItem("theme");
    if (bookmarksStorage) state.bookmarks = JSON.parse(bookmarksStorage);
    if (ingListStorage) state.ingredientsList = JSON.parse(ingListStorage);
    if (!ingListStorage) state.ingredientsList = [
        "My shopping list"
    ];
    if (plannedMealsStorage) state.planner = JSON.parse(plannedMealsStorage);
    if (themeStorage) state.theme = JSON.parse(themeStorage);
    // Sense time
    if (mondayStorage) state.lastMonday = new Date(JSON.parse(mondayStorage));
    if (!mondayStorage) state.lastMonday = new Date((0, _configJs.FIRST_MONDAY));
    updateDate();
};
init();

},{"./config.js":"cTPit","./helpers.js":"rOFoc","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"cTPit":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API_URL", ()=>API_URL);
parcelHelpers.export(exports, "TIMEOUT_SEC", ()=>TIMEOUT_SEC);
parcelHelpers.export(exports, "RES_PER_PAGE", ()=>RES_PER_PAGE);
parcelHelpers.export(exports, "KEY", ()=>KEY);
parcelHelpers.export(exports, "MODAL_CLOSE_SEC", ()=>MODAL_CLOSE_SEC);
parcelHelpers.export(exports, "SERVINGS_TO_UPLOAD", ()=>SERVINGS_TO_UPLOAD);
parcelHelpers.export(exports, "SPOONACULAR_ENDPOINT", ()=>SPOONACULAR_ENDPOINT);
parcelHelpers.export(exports, "SPOONACULAR_API_KEY", ()=>SPOONACULAR_API_KEY);
parcelHelpers.export(exports, "MS_PER_DAY", ()=>MS_PER_DAY);
parcelHelpers.export(exports, "FIRST_MONDAY", ()=>FIRST_MONDAY);
const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
const TIMEOUT_SEC = 10;
const RES_PER_PAGE = 10;
const KEY = "bdb5393b-7e54-4c24-bade-41baec3a3a8e";
const MODAL_CLOSE_SEC = 2.5;
const SERVINGS_TO_UPLOAD = 4;
const SPOONACULAR_ENDPOINT = `https://api.spoonacular.com/recipes/parseIngredients`;
const SPOONACULAR_API_KEY = "1fed54ff99014540acce11d0955733fb";
const MS_PER_DAY = 86400000;
const FIRST_MONDAY = new Date(0).getTime() + 4 * MS_PER_DAY;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"83weF":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"rOFoc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AJAX", ()=>AJAX);
parcelHelpers.export(exports, "formatIngredientsArr", ()=>formatIngredientsArr);
parcelHelpers.export(exports, "maxFourWords", ()=>maxFourWords);
parcelHelpers.export(exports, "calcDaysPassed", ()=>calcDaysPassed);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
var _configJs = require("./config.js");
const timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const AJAX = async function(url, uploadData, contentType) {
    try {
        const fetchPro = uploadData ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": contentType
            },
            body: contentType === `application/json` ? JSON.stringify(uploadData) : new URLSearchParams(uploadData)
        }) : fetch(url);
        const response = await Promise.race([
            fetchPro,
            timeout((0, _configJs.TIMEOUT_SEC))
        ]);
        const data = await response.json();
        if (!response.ok) throw new Error(`${data.message} ${response.status}`);
        return data;
    } catch (err) {
        throw err;
    }
};
const formatIngredientsArr = function(newRecipe) {
    const ingredientsDataArr = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith("ingredient")).map((ingData)=>{
        const ingIndex = +ingData[0].split("-").slice(-2, -1) - 1;
        const [ingType] = ingData[0].split("-").slice(-1);
        const ingValue = ingData[1];
        return [
            ingIndex,
            ingType,
            ingValue
        ];
    });
    const ingQuantity = ingredientsDataArr.filter((curr)=>curr[1] === "quantity");
    const ingUnit = ingredientsDataArr.filter((curr)=>curr[1] === "unit");
    const ingDescription = ingredientsDataArr.filter((curr)=>curr[1] === "description");
    const ingredients = [];
    for(let i = 0; i < 8; i++){
        if (ingQuantity[i][2] === "" && ingUnit[i][2] === "" && ingDescription[i][2] === "") break;
        ingredients.push({
            quantity: ingQuantity[i][2] ? +ingQuantity[i][2] : null,
            unit: ingUnit[i][2],
            description: ingDescription[i][2]
        });
    }
    return ingredients;
};
const maxFourWords = function(string) {
    const words = string.split(" ");
    if (words.length <= 4) return string;
    if (words.length > 4) return words.filter((_, i)=>i < 4).join(" ") + "...";
};
const calcDaysPassed = function(date1, date2) {
    return Math.abs(date2 - date1) / (0, _configJs.MS_PER_DAY);
};
const formatDate = function() {
    const options = {
        day: "numeric",
        weekday: "long",
        month: "long",
        year: "numeric"
    };
    return new Intl.DateTimeFormat("en-US", options).format(new Date());
};

},{"./config.js":"cTPit","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"lslfl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iconsSvg = require("url:../../img/icons.svg");
var _iconsSvgDefault = parcelHelpers.interopDefault(_iconsSvg);
class View {
    _data;
    /**
   * Render the recived object to the DOM
   * @param {Object | Object[]} data The data to be rendered (e.g. recipe)
   * @param {boolean} [render = true] If false create markup string instead of rendering to the DOM
   * @returns {undefined | string} A markup string is returned when render = false
   * @this {Object} View Instance
   */ render(data, render = true) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        //Create dom object living in the memory - makes it simple to compare
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const currentElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const curEl = currentElements[i];
            //Updates changed text
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") curEl.textContent = newEl.textContent;
            //Update changed ATTRIBUTES
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    renderSpinner() {
        const markup = `
    <div class="spinner">
            <svg>
              <use href="${(0, _iconsSvgDefault.default)}#icon-loader"></use>
            </svg>
          </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderError(message = this._errorMessage) {
        const markup = `
      <div class="error">
            <div>
              <svg>
                <use href="${(0, _iconsSvgDefault.default)}#icon-alert-triangle"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>
      `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderMessage(message = this._message) {
        const markup = `
      <div class="message">
            <div>
              <svg>
                <use href="${(0, _iconsSvgDefault.default)}#icon-smile"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>
      `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}
exports.default = View;

},{"url:../../img/icons.svg":"ikxed","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"ikxed":[function(require,module,exports) {
module.exports = require("e3bc46e0cd948a74").getBundleURL("4vDYv") + "icons.7bb96926.svg";

},{"e3bc46e0cd948a74":"7Ve2W"}],"htPRE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class ThemeView {
    _parentElement = document.documentElement;
    _sliderBtn = document.querySelector(".slider__circle");
    setTheme(theme) {
        document.documentElement.dataset.theme = theme;
        document.querySelector(".slider__circle").style.left = theme === "dark" ? "4.5rem" : "1rem";
    }
    addHandlerChangeTheme(handler) {
        document.querySelector(".slider").addEventListener("click", function() {
            const actualTheme = document.documentElement.dataset.theme;
            //   console.log(actualTheme);
            handler(actualTheme);
        });
    }
}
exports.default = new ThemeView();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"j1Ujo":[function(require,module,exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
    else Function("r", "regeneratorRuntime = r")(runtime);
}

},{}]},["i3eB5"], null, "parcelRequire3a11")

//# sourceMappingURL=index.1b5fdb01.js.map
